/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The props for `<Overlay />`.
 */
export interface OverlayProps {
  /**
   * Display overlay across the entire screen.
   */
  fullScreen?: boolean;
}

/**
 * The default prop values for `<Overlay />`.
 */
export const overlayPropsDefaults = {
  fullScreen: true,
};
